import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";


// Import images

const NewsAndStorySlider = () => {
  const [personalInfo, setPersonalInfo] = useState([]);
  const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state

  const fetchNewAndStory = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getLatestStoriesNews`);
      console.log("latest story data",response)
      setProfileImg(response.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewAndStory();
  }, []); 
  return (
    <div className="institute-slider-container row">
      {/* Show loader if data is still being fetched */}
      {loading ? (
        <p>Loading institutes...</p>
      ) : profileImg.length > 0 ? (
        <OwlCarousel
          className="owl-theme"
          loop
          margin={15}
          nav
          autoplay
          autoplayTimeout={3000}
          responsive={{
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          }}
        >
          {profileImg.map((profile, index) => (
            <div class="col-md-12 col-lg-12"  key={profile.id || index}>
              <div class="blog-item wow fadeInUp" data-wow-delay=".25s">
                <div class="blog-item-info">
                  <h4 class="blog-title">
                    {/* <a href="">There are many variations passage have suffered available.</a> */}
                    <a href="">{profile.name}</a>
                  </h4>
                  <div class="blog-item-meta">
                    <ul>
                      {/* <li><a href="#"><i class="fal fa-calendar-alt"></i> June 18, 2024</a></li> */}
                      <li><a href="#"><i class="fal fa-calendar-alt"></i> {profile?.date ? new Date(profile.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : ""}</a></li>
                      
                      {/* <li><a href="#"><i class="far fa-comments"></i> 03 Comments</a></li> */}
                    </ul>
                  </div>
                  {/* <p>{profile?.description}</p> */}
                  <p dangerouslySetInnerHTML={{ __html: profile?.description}} />
                  {/* <p>MHT CET 2024 23 April Shift 1 question paper is available for download here. MHT CET 2024 question paper comprises 200 MCQs carrying a total weight...</p> */}
                  <div class="course-bottom">
                    <div class="course-bottom-left">
                      <a href="#">
                        <span>Read More</span> 
                      </a>
                    </div> 
                    <span><a href="#"><i class="far fa-arrow-right"></i></a></span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </OwlCarousel>
      ) : (
        <p>No Places available.</p>
      )}
    </div>
  );
};

export default NewsAndStorySlider;